"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCalculateRiskInsuranceRequest = instanceOfCalculateRiskInsuranceRequest;
exports.CalculateRiskInsuranceRequestFromJSON = CalculateRiskInsuranceRequestFromJSON;
exports.CalculateRiskInsuranceRequestFromJSONTyped = CalculateRiskInsuranceRequestFromJSONTyped;
exports.CalculateRiskInsuranceRequestToJSON = CalculateRiskInsuranceRequestToJSON;
exports.CalculateRiskInsuranceRequestToJSONTyped = CalculateRiskInsuranceRequestToJSONTyped;
/**
 * Check if a given object implements the CalculateRiskInsuranceRequest interface.
 */
function instanceOfCalculateRiskInsuranceRequest(value) {
    if (!('birthYear' in value) || value['birthYear'] === undefined)
        return false;
    if (!('durationYears' in value) || value['durationYears'] === undefined)
        return false;
    if (!('riskInsuranceAmount' in value) || value['riskInsuranceAmount'] === undefined)
        return false;
    if (!('riskInsurance' in value) || value['riskInsurance'] === undefined)
        return false;
    if (!('creditInsurance' in value) || value['creditInsurance'] === undefined)
        return false;
    if (!('disability' in value) || value['disability'] === undefined)
        return false;
    if (!('accidentProtection' in value) || value['accidentProtection'] === undefined)
        return false;
    if (!('dreadDisease' in value) || value['dreadDisease'] === undefined)
        return false;
    return true;
}
function CalculateRiskInsuranceRequestFromJSON(json) {
    return CalculateRiskInsuranceRequestFromJSONTyped(json, false);
}
function CalculateRiskInsuranceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'birthYear': json['birthYear'],
        'durationYears': json['durationYears'],
        'riskInsuranceAmount': json['riskInsuranceAmount'],
        'riskInsurance': json['riskInsurance'],
        'creditInsurance': json['creditInsurance'],
        'disability': json['disability'],
        'accidentProtection': json['accidentProtection'],
        'dreadDisease': json['dreadDisease'],
    };
}
function CalculateRiskInsuranceRequestToJSON(json) {
    return CalculateRiskInsuranceRequestToJSONTyped(json, false);
}
function CalculateRiskInsuranceRequestToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'birthYear': value['birthYear'],
        'durationYears': value['durationYears'],
        'riskInsuranceAmount': value['riskInsuranceAmount'],
        'riskInsurance': value['riskInsurance'],
        'creditInsurance': value['creditInsurance'],
        'disability': value['disability'],
        'accidentProtection': value['accidentProtection'],
        'dreadDisease': value['dreadDisease'],
    };
}
